import { useMutation, useQueryClient } from "@tanstack/react-query";
import { configuration } from "../../../configuration";
import { EditActionItemSortOrderDto, FetchError } from "../../types";
import { useAccessToken } from "../../use-access-token";
import { queryKeys } from "../queryKeys";

type Variables = {
  actionItemGuid: string;
  sectionGuid: string;
  sortOrder: string;
  planGuid?: string;
};

const useEditActionItemSortOrderRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function editActionItemSortOrderRequest(variables: Variables): Promise<void> {
    const accessToken = await getAccessToken();
    const body: EditActionItemSortOrderDto = {
      sectionGuid: variables.sectionGuid,
      sortOrder: variables.sortOrder,
    };

    const response = await fetch(`${configuration.apiRootUrl}/action-items/${variables.actionItemGuid}/sort-order`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      method: "put",
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new FetchError(response);
    }
  }

  return { editActionItemSortOrderRequest };
};

const useEditActionItemSortOrder = () => {
  const { editActionItemSortOrderRequest } = useEditActionItemSortOrderRequest();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: editActionItemSortOrderRequest,
    onSettled: async (_data, _error, variables) => {
      if (variables.planGuid) {
        queryClient.invalidateQueries(queryKeys.plans.getPlan(variables.planGuid));
        queryClient.invalidateQueries(queryKeys.plans.getPlanSubitems(variables.planGuid));
      }
    },
  });
};

export { useEditActionItemSortOrder };
